import {
  loyaltyProgramLevelNames,
  loyaltyProgramLevelsList,
  loyaltyProgramNames,
  merchantsHaveDynamicLevels
} from 'components/ReusableComponents/Arrivals/LoyaltyIcon/loyaltyLevels'

export const checkLoyaltyProgram = (groupName, parentChain) => {
  if (merchantsHaveDynamicLevels.includes(groupName)) {
    return true
  } else {
    return loyaltyProgramLevelNames[parentChain]
  }
}

export const getLoyaltyProgramLevelTitle = parentChain => {
  return loyaltyProgramNames[parentChain]
}

export const getloyaltyProgramLevelsList = parentChain => {
  const hasLoyaltyProgram = checkLoyaltyProgram(null, parentChain)
  if (hasLoyaltyProgram) {
    return loyaltyProgramLevelsList[parentChain]
  }
}

export const getLoyaltyProgramLevelName = (parentChain, level) => {
  const hasLoyaltyProgram = checkLoyaltyProgram(null, parentChain)
  if (hasLoyaltyProgram) {
    const hotelLoyaltyLevels = loyaltyProgramLevelNames[parentChain]
    if (hotelLoyaltyLevels) {
      return hotelLoyaltyLevels[level]
    }
  }

  return null
}
